// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"159":"676e7eb7","437":"1ecf3cab","950":"313465eb"}[chunkId] + ".css";
};